module.exports = __webpack_public_path__ + "img/03.61172f3a.png";